// Central theme registry.
// Adding a new theme is as simple as adding an entry here and providing
// its components under src/themes/<id>/. Backend / database stay untouched.

export const THEME_IDS = {
  THEME1: 'theme1',
  THEME2: 'theme2',
};

// Theme 2 is the live/global default. The admin can still force Theme 1 by
// saving active_theme = 'theme1' in site settings (DB value overrides this).
export const DEFAULT_THEME = THEME_IDS.THEME2;

export const THEMES = [
  {
    id: THEME_IDS.THEME1,
    name: 'Theme 1',
    label: 'Classic',
    description: 'The current existing website design. Stable, familiar and unchanged.',
    accent: '#3B82F6',
    tags: ['Current', 'Default', 'Stable'],
  },
  {
    id: THEME_IDS.THEME2,
    name: 'Theme 2',
    label: 'Modern Motion',
    description:
      'A premium, high-end agency experience with parallax, micro-interactions, glass effects, light/dark mode and smooth motion.',
    accent: '#6366F1',
    tags: ['Premium', 'Animated', 'Light/Dark'],
  },
];

export const isValidTheme = (id) => THEMES.some((t) => t.id === id);

export const getThemeMeta = (id) =>
  THEMES.find((t) => t.id === id) || THEMES.find((t) => t.id === DEFAULT_THEME);
